import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Rekprof logo",
  class: "logo_min",
  src: "../../assets/logo.png"
}, null, -1)
const _hoisted_2 = { class: "inner_step_box" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "main_field" }, "Введите ФИО заявителя", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left hint_mini_top" }, "Фамилия", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left" }, "Имя", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left" }, "Отчество", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left" }, "В лице (Генерального Директора)", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left" }, "В лице (Иванова Ивана Ивановича)", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "hint_left" }, "Выберите пол", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "main_checkbox" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "skip_patronymic" }, "Отчество отсутствует", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = { class: "hint_left hint_mini_top" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_menu_proxy_list = _resolveComponent("v-menu-proxy-list")!
  const _component_v_select_open = _resolveComponent("v-select-open")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_v_menu_proxy_list),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        class: "main_input",
        placeholder: "Введите фамилию",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.storeDM.save_obj.declarer_lastname) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.declarer_lastname]
      ]),
      _hoisted_5,
      _hoisted_6,
      _withDirectives(_createElementVNode("input", {
        class: "main_input",
        placeholder: "Введите имя",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.storeDM.save_obj.declarer_firstname) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.declarer_firstname]
      ]),
      _hoisted_7,
      _hoisted_8,
      _withDirectives(_createElementVNode("input", {
        class: "main_input",
        placeholder: "Введите отчество",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.storeDM.save_obj.declarer_patronymic) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.declarer_patronymic]
      ]),
      _hoisted_9,
      _hoisted_10,
      _withDirectives(_createElementVNode("input", {
        class: "main_input",
        placeholder: "Генерального Директора",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.storeDM.save_obj.client_role) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.client_role]
      ]),
      _hoisted_11,
      _hoisted_12,
      _withDirectives(_createElementVNode("input", {
        class: "main_input",
        placeholder: "Иванова Ивана Ивановича",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.storeDM.save_obj.client_role_fio_genitive) = $event))
      }, null, 512), [
        [_vModelText, _ctx.storeDM.save_obj.client_role_fio_genitive]
      ]),
      _hoisted_13,
      _hoisted_14,
      (_openBlock(), _createBlock(_component_v_select_open, {
        options: _ctx.declarer_genre_options,
        title_select: _ctx.declarer_genre_title,
        default_select: _ctx.storeDM.save_obj.declarer_genre,
        key: _ctx.storeDM.save_obj.declarer_genre,
        onChangeSelect: _ctx.declarer_genre_select,
        margin_top: '-6px',
        z_index: 1
      }, null, 8, ["options", "title_select", "default_select", "onChangeSelect"])),
      _hoisted_15,
      _hoisted_16,
      _hoisted_17,
      _createElementVNode("p", _hoisted_18, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          id: "skip_patronymic",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.storeDM.save_obj.declarer_patronymic_no) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.storeDM.save_obj.declarer_patronymic_no]
        ]),
        _hoisted_19
      ]),
      _hoisted_20,
      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.signature_decl_file_hint), 1),
      _createElementVNode("input", {
        ref: "signature_decl_file",
        type: "file",
        hidden: "",
        onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitFile('signature_decl_file')))
      }, null, 544),
      _createElementVNode("button", {
        type: "button",
        class: "blue_btn",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$refs.signature_decl_file.click())),
        style: {"float":"left","margin-left":"10px"}
      }, " Загрузить файл подписи "),
      _hoisted_22
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "white_s_btn",
      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.go_back()))
    }, "Назад"),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["next_btn", { active_btn: _ctx.step_next }]),
      disabled: !_ctx.step_next,
      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.go_next()))
    }, " Далее ", 10, _hoisted_23)
  ], 64))
}